// Create Query Use Case
import { QueriesRepository } from "../repositories/QueriesRepository";
import { QueryEntity, CreateQueryParams } from "../entities/QueryEntity";
import { Result } from "../common/Result";

export class CreateQueryUseCase {
  constructor(private repository: QueriesRepository) {}

  async execute(params: CreateQueryParams): Promise<Result<QueryEntity>> {
    try {
      // Business logic validation
      if (!params.title || params.title.trim().length < 3) {
        return Result.fail("Title must be at least 3 characters");
      }

      if (params.description && params.description.length > 1000) {
        return Result.fail("Description cannot exceed 1000 characters");
      }

      const query = await this.repository.create(params);
      return Result.ok(query);
    } catch (error: any) {
      return Result.fail(error.message || "Failed to create query");
    }
  }
}

